module.exports = _.max;